import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import React, { useEffect } from 'react';
import { selectPlacementLandsGtgDetails } from '../../../../../../../store/redux-store/placement-details/selectors';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { FormInputText } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputText';
import { useFormContext } from 'react-hook-form';
import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()({
  container: {
    padding: '12px 0px 0px 7px',
  },
});
export const NotRequiredReason = props => {
  const { t } = useTranslation();
  const selectLandsGtgDetails = useSelector(selectPlacementLandsGtgDetails);
  const { classes } = useStyles();
  const { formState: { errors }, setValue, getValues } = useFormContext();

  useEffect(() => {
    if (!selectLandsGtgDetails?.gtgNotRequiredReasonId && props.notRequiredReasonsList) {
      setValue('pNotRequiredReasonId', props.notRequiredReasonsList[0]?.Id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleReasonChange = e => {
    setValue('pNotRequiredReasonId', e.target.value, { shouldDirty: true });
    props.handleFieldChanges?.();
  };

  const handleCommentChange = e => {
    setValue('pNotRequiredReason', e.target.value, { shouldDirty: true });
    props.handleFieldChanges?.();
  };

  return (
    <>
      <LayoutGridItem className={classes.container}>
        <LayoutGrid direction="row" justifyContent="space-between">
          <LayoutGridItem style={{ width: '33.33%' }}>
            <FormInputDropdown
              name={'pNotRequiredReasonId'}
              label={t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.notRequiredReason.reason')}
              require={false}
              options={
                getValues('pNotRequiredReasonId') || selectLandsGtgDetails?.gtgNotRequiredReasonId
                  ? props.notRequiredReasonsList
                  : [null, ...props.notRequiredReasonsList]
              }
              handleChange={handleReasonChange}
              inputValue={
                props.notRequiredReasonsList?.find(
                  item => parseInt(item.Id) === selectLandsGtgDetails?.gtgNotRequiredReasonId,
                )?.Description
              }
              readOnly={!props.hasEditPermission}
              isCheckBox={true}
            />
          </LayoutGridItem>
          <LayoutGridItem style={{ width: '65%' }}>
            <FormInputText
              name="pNotRequiredReason"
              label={t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.notRequiredReason.enterComment')}
              handleChange={handleCommentChange}
              require={false}
              message={errors['pNotRequiredReason']?.message || ''}
              inputValue={selectLandsGtgDetails?.gtgNotRequiredReason || undefined}
              readOnly={!props.hasEditPermission}
            />
          </LayoutGridItem>
        </LayoutGrid>
      </LayoutGridItem>
    </>
  );
};
